import Footer from "@components/Footer"
import Image from "@components/Image"
import { Box, Container } from "@components/Layout"
import SEO from "@components/SEO"
import { Paragraph, TitleXL } from "@components/Typography"
import { getKontentImage, getPageByCodename } from "@lib/kontent"
import { WarrantyPage } from "@lib/kontent/models-deprecated/warranty_page"
import { PageProps } from "@lib/types"
import { ErrorPage } from "@screens/error"
import Form from "@screens/warranty/Form"
import { NextPage } from "next"
import React from "react"

type Props = PageProps<{ content: WarrantyPage }>

const Warranty: NextPage<Props> = ({ statusCode, data }) => {
  if (statusCode || !data) {
    return <ErrorPage statusCode={statusCode} />
  }

  return (
    <>
      <SEO
        title={data.content.seoMetaTitle.value}
        description={data.content.seoMetaDescription.value}
        imageUrl={data.content.seoMetaImage.value[0]?.url}
        urlKey="warranty"
      />
      <Box pt={["6rem"]}>
        {data.content.pageIntroHero.value[0] && (
          <Box position="relative">
            <Image
              variant="full-width"
              src={getKontentImage(data.content.pageIntroHero.value[0].url, {
                width: 1200,
              })}
              alt="background"
            />
          </Box>
        )}

        <Container pt={["5rem"]} pb={"6rem"} maxWidth="50rem">
          <TitleXL as="h2">{data.content.pageIntroTitle.value}</TitleXL>
          <Paragraph style={{ whiteSpace: "pre-wrap", marginBottom: "1rem" }}>
            {data.content.pageIntroText.value}
          </Paragraph>
          <Box py={5}>
            <Form />
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  )
}

Warranty.getInitialProps = async ({ lang }) => {
  try {
    const content = await getPageByCodename({ codename: "warranty", lang })
    if (!content) {
      return { statusCode: 404 }
    }
    return {
      data: { content: content.item as WarrantyPage },
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500 }
  }
}

export default Warranty
